<template>
  <div class="footerbox">
    <div class="banner">
      <img src="@/assets/other/concat.jpg" style="width: 100%" alt="" />
    </div>
    <Nav title="联系我们" />
    <!--  底部  -->
    <div class="bottom-box">
      <div class="pagew bottom">
        <div class="zhuban-box">
          <div class="stle-box">
            <div class="cont" style="width: 800px">
              <h3 style="margin-bottom:10px">湖南旭麓新材料科技有限公司</h3>
              <div class="logo-img">
                <span class="spantitle">联系人：</span><span>周女士</span>
              </div>
              <div class="logo-img">
                <span class="spantitle">手机号码：</span
                ><span>13681028069</span>
              </div>
              <div class="logo-img">
                <span class="spantitle">QQ：</span><span>1763707622</span>
              </div>
              <div class="logo-img">
                <span class="spantitle">公司地址：</span
                ><span
                  >湖南省长沙市岳麓山大学科技城岳麓街道溁左路中南大学科技园研发总部1栋264房</span
                >
              </div>
              <div class="logo-img">
                <span class="spantitle">邮政编码：</span><span>410083</span>
              </div>
              <div class="bottom-img">
                <img src="@/assets/other/lianxiwomen.jpg" alt="" style="height: 200px;width: 200px; "/>
                <img src="@/assets/other/8.jpg" alt="" style="height: 200px;width: 200px; "/>
              </div>
              <!-- <div class="logo-img">
                <span class="spantitle">网站：</span><span>xxxxxxxxxxx</span>
              </div> -->
              <!--              <div class="logo-img"><span class="spantitle">成立日期：</span><span>2019年4月29日</span> </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer :show="true" />
  </div>
</template>

<script>
import Nav from "../../components/Nav/Nav.vue";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  components: { Nav },
  methods: {
    goSign() {
      this.$router.push({
        path: "/Signup"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.footerbox {
  width: 100%;
  .banner {
    margin-top: 82px;
  }

  .footer-about {
    width: 100%;
    height: 240px;
    background: url("../../assets/image/back.png") no-repeat;
    background-position: center;

    .title {
      padding: 20px 0;
      font-size: 20px;
      font-weight: bold;
    }

    .content {
      width: 62%;
      margin: 0 auto;
      text-align: left;
      text-indent: 2em;
      line-height: 25px;
    }
  }

  .add {
    width: 100%;
    height: 200px;
    // margin-bottom: 40px;
    background: url("../../assets/image/rightnow.png") no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;

    .sign {
      cursor: pointer;
      position: absolute;
      right: 640px;
      top: 75px;
      width: 200px;
      height: 60px;
      background-color: #ffffff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #25877d;

      .imgsize {
        width: 15px;
        height: 15px;
        margin: 3px 0 0 20px;
      }
    }
  }

  .bottom {
    .b-cont {
      width: 100%;
      display: flex;

      .cont {
        text-align: left;
        width: 25%;
        font-weight: bold;
        font-size: 18px;
        // padding-bottom: 30px;
      }

      .img {
        display: flex;
        width: 100%;

        .imgbox {
          width: 25%;
        }
      }
    }

    .tel {
      width: 100%;
      margin-top: 20px;
      margin-left: 10px;

      .title {
        text-align: left;
        font-weight: bold;
        font-size: 18px;
        padding-bottom: 20px;
      }

      .box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .boxitem {
          width: 100%;

          .each {
            width: 100%;
            margin-bottom: 20px;

            .title {
              text-align: left;
              font-weight: bold;
              font-size: 18px;
            }

            .foorter {
              .user {
                width: 100%;
                display: flex;
                flex-wrap: wrap;

                div {
                  width: 33%;
                }
              }

              text-align: left;
              display: flex;

              div {
                width: 50%;
              }
            }

            .address {
              text-align: left;
              padding-top: 10px;
              display: flex;
              justify-content: space-between;
            }
          }
        }
      }
    }
  }
}
.bottom-box {
  padding-top: 10px;
  background-color: #f8f5f0;
  .stle-box {
    display: flex;
    // font-weight: 700;
    padding-left: 10px;
    font-size: 18px;
    // line-height: 50px;
    text-align: left;
  }
}
.zhuban-logo {
  display: flex;
  align-content: center;
  .logo-img {
    margin-right: 10px;
  }
}

.beian {
  padding: 5px 0;
  font-size: 14px;
  text-align: center;
  width: 150px;
  text-align: center;
  white-space: nowrap;
}
// .logo-img span.spantitle {
//   text-align: right;
//   width: 100px;
// }
.logo-img span {
  line-height: 30px;
  font-size: 16px;
  text-align: left;
  // display: inline-block;
  // margin-right: 18px;
  // font-weight: normal;
}
.code {
  width: 140px;
  position: absolute;
  right: 5px;
  top: 60px;
}
.bottom {
  position: relative;
}
.bottom-img {
  display: flex;
  width: 500px;
  height: 200px;
  margin-top: 20px;
  // img {
  //   &:nth-child(2) {
  //     margin-top: 20px;
  //     width: 400px;
  //     height: 150px;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/view/homePage/contactus.vue